namespace TabAurous.OMS {
    export interface DepartmentProcessDetailsRow {
        DetailId?: number;
        DepartmentId?: number;
        ProcessId?: number;
        ProcessCode?: string;
        ProcessName?: string;
        DeptName?: string;
    }

    export namespace DepartmentProcessDetailsRow {
        export const idProperty = 'DetailId';
        export const nameProperty = 'ProcessName';
        export const localTextPrefix = 'OMS.DepartmentProcessDetails';
        export const lookupKey = 'OMS.ProcessDepartment';

        export function getLookup(): Q.Lookup<DepartmentProcessDetailsRow> {
            return Q.getLookup<DepartmentProcessDetailsRow>('OMS.ProcessDepartment');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            DetailId = "DetailId",
            DepartmentId = "DepartmentId",
            ProcessId = "ProcessId",
            ProcessCode = "ProcessCode",
            ProcessName = "ProcessName",
            DeptName = "DeptName"
        }
    }
}
